@let layout = store.layoutSg();
@let rowToolsWidthPx = store.rowToolsWidthPxSg();
@let selection = store.selectionConfigSg();
@let wrap = store.wrapSg();

<div
  class="atn-ds-table-column-headers"
  cdkDropList
  cdkDropListLockAxis="x"
  [cdkDropListSortingDisabled]="true"
  [style.grid-template-columns]="layout.gridTemplateColumns"
>
  @if (selection) {
    <div class="atn-ds-table-column-headers__cell">
      <atn-ds-checkbox
        [disabled]="!selection.onAllChange"
        [selected]="selection.allSelected ?? false"
        [someSelected]="selection.someSelected ?? false"
        (selectedChange)="store.changeAllSelection($event)"
      />
    </div>
  }

  @for (column of layout.columns; track column.id) {
    <div
      class="atn-ds-table-column-headers__cell"
      [style.text-align]="column.align"
    >
      <div
        class="atn-ds-table-column-headers__content"
        [class.atn-ds-table-column-headers__content--wrapped]="wrap"
        [attr.title]="column.config.description"
      >
        @if (column.config.sort; as sort) {
          <button
            #columnContent
            class="atn-ds-table-column-headers__sort"
            [attr.aria-label]="'Sort by ' + column.config.label"
            [attr.aria-sort]="sort.direction ?? 'none'"
            [attr.data-column-id]="column.id"
            type="button"
            (click)="columnSortClickHandler(sort)"
          >
            <span
              class="atn-ds-table-column-headers__label"
              [class.atn-ds-table-column-headers__label--wrapped]="wrap"
            >
              {{ column.config.label }}
            </span>
            @if (sort.direction) {
              <i
                class="fa atn-ds-table-column-headers__sort-icon"
                [class.fa-arrow-down]="sort.direction === 'descending'"
                [class.fa-arrow-up]="sort.direction === 'ascending'"
              ></i>
            }
          </button>
        } @else {
          <span
            class="atn-ds-table-column-headers__label"
            [class.atn-ds-table-column-headers__label--wrapped]="wrap"
            #columnContent
            [attr.data-column-id]="column.id"
          >
            {{ column.config.label }}
          </span>
        }
      </div>
      @if (column.config.resizable !== false) {
        <div
          class="atn-ds-table-column-headers__resize-handle"
          cdkDrag
          (cdkDragDropped)="columnResizeDroppedHandler($event, column.id)"
          (dblclick)="columnDblClickHandler(column.id)"
        >
          <div class="atn-ds-table-column-headers__resize-divider"></div>
        </div>
      }
    </div>
  }
  @if (rowToolsWidthPx) {
    <div class="atn-ds-table-column-headers__cell"></div>
  }
</div>
